export const MERCHANT_ID = "MERCHANT_ID"
export const BANK_ID = "BANK_ID"
export const FACEPAY_ID = "FACEPAY_ID"
export const INTERVAL = "INTERVAL"

export const PROFILE_ID = "PROFILE_ID"
export const BIOMETRIC_ID = "BIOMETRIC_ID"

export const DEFAULT_VAL = "-"